module.exports = __webpack_public_path__ + "static/media/anc1ru.a5c128d6.pdf";